import mixpanel from 'mixpanel-browser';
import { useCallback } from 'react';

import { FilterInteractionTrackingEvents } from '@revelio/core';

import type { ShortcutSource } from '../../../../shared/components/tree/shortcut-source';
import { useOptionalRevelioPageId } from '../../components/PageConfigProvider/PageConfigProvider';
import type { Filter } from '../types/filters';

/**
 * `entity shortcut added`: a pick made without the tree — a recents /
 * competitors / trial-plan chip, or the company info tooltip's parent and
 * competitor controls. Fires on the add, whether or not the form is then
 * submitted; at apply time every one of these reads as `shortlist` in the
 * `selection_source` of `filters applied`.
 */
export const useTrackEntityShortcutAdded = () => {
  const pageId = useOptionalRevelioPageId();

  return useCallback(
    (
      filter: Pick<Filter, 'id' | 'type'>,
      { source, levelId }: { source: ShortcutSource; levelId?: string }
    ) => {
      mixpanel.track(FilterInteractionTrackingEvents.ENTITY_SHORTCUT_ADDED, {
        source,
        filter_id: filter.id,
        filter_type: filter.type,
        page_id: pageId,
        ...(levelId !== undefined && { entity_level_id: levelId }),
      });
    },
    [pageId]
  );
};
